<template>
  <div class="dqcz_wrap">
    <div class="latest_box">
      <div class="title_box">
        <div class="title">最新操作</div>

        <div class="text">
          <span class="txt1">AI搜索</span>
          <span class="sp_animation sp_animation1"></span>
          <span class="sp_animation sp_animation2"></span>
          <span class="sp_animation sp_animation3"></span>
          <span class="sp_animation sp_animation4"></span>
          <span class="sp_animation sp_animation5"></span>

          <div class="counter_container">
            <!-- <span class="counter_value">
              <span>{{ currentValue }}</span
              >%
            </span> -->

            <span class="open open0" v-if="openStatus == 0"
              >休市中，不进行操作</span
            >
            <span class="open open1" v-if="openStatus == 1">盘中实时搜索</span>
          </div>
        </div>
      </div>

      <div class="list_box">
        <div class="list_empty" v-if="latestEmpty">
          <span class="txt1"
            >盘中9:30-11:30，13:00-15:00实时选股，目前暂无符合因子，无操作</span
          >
          <span class="sp_animation sp_animation1"></span>
          <span class="sp_animation sp_animation2"></span>
          <span class="sp_animation sp_animation3"></span>
          <span class="sp_animation sp_animation4"></span>
          <span class="sp_animation sp_animation5"></span>
        </div>

        <div class="item_box" v-for="(item, index) in latestList" :key="index">
          <div class="stock_box">
            <div class="stock">{{ item.stockName }}/{{ item.stockCode }}</div>

            <div class="time">{{ item.eventTime }}</div>

            <div class="type">
              {{
                item.eventType == 0
                  ? "买入"
                  : item.eventType == 2 || item.eventType == 3
                  ? "卖出"
                  : item.eventType == 4
                  ? "调整止盈止损"
                  : ""
              }}
            </div>

            <div class="price">
              {{
                item.eventType == 0
                  ? `建议买入价格：${COMMON.formatToFixed(item.buyPrice)}`
                  : item.eventType == 2 || item.eventType == 3
                  ? `建议卖出价格：${COMMON.formatToFixed(item.sellPrice)}`
                  : item.eventType == 4
                  ? `入选时买入价格：${COMMON.formatToFixed(item.buyPrice)}`
                  : ""
              }}
            </div>

            <div class="zyzs_box">
              <div class="zyzs" v-if="item.eventType == 0">
                <div>
                  止盈：{{ COMMON.formatToFixed(item.stopProfitPrice) }}
                </div>

                <div>止损：{{ COMMON.formatToFixed(item.stopLossPrice) }}</div>
              </div>

              <div
                class="zyzs"
                v-else-if="item.eventType == 2 || item.eventType == 3"
              >
                {{
                  [2, 3].includes(item.eventType)
                    ? `已达${item.eventType == 2 ? "止盈" : "止损"}`
                    : ""
                }}
              </div>

              <div class="zyzs" v-else-if="item.eventType == 4">
                <div>
                  止盈：{{ COMMON.formatToFixed(item.beforeStopProfitPrice) }} →
                  {{
                    item.stopProfitPrice == item.beforeStopProfitPrice
                      ? ""
                      : item.stopProfitPrice > item.beforeStopProfitPrice
                      ? "↑"
                      : "↓"
                  }}{{ COMMON.formatToFixed(item.stopProfitPrice) }}
                </div>

                <div>
                  止损：{{ COMMON.formatToFixed(item.beforeStopLossPrice) }} →
                  {{
                    item.stopLossPrice == item.beforeStopLossPrice
                      ? ""
                      : item.stopLossPrice > item.beforeStopLossPrice
                      ? "↑"
                      : "↓"
                  }}{{ COMMON.formatToFixed(item.stopLossPrice) }}
                </div>
              </div>
            </div>
          </div>

          <!-- <div class="inform_box">
            通知：<span class="time">{{ item.noticeList[0].createTime }}</span
            ><span class="content">{{ item.noticeList[0].content }}</span
            ><span class="btn" @click="msgDetailsClick(item)"
              >点击查看详情</span
            >
          </div> -->
        </div>
      </div>
    </div>

    <div class="stockHold_box">
      <div class="title_box">
        <div class="title">当前持仓</div>
      </div>

      <div class="list_container">
        <el-affix target=".list_container" :offset="112">
          <div
            class="list_nav"
            :class="{ list_nav_length: computedStockHoldList.length > 9 }"
          >
            <div class="nav nav1"></div>
            <div class="nav nav2">股票名称</div>
            <div class="nav nav3">入选时间</div>
            <div class="nav nav4">建议买入价格</div>
            <div class="nav nav5">建议止盈</div>
            <div class="nav nav6">建议止损</div>
            <div class="nav nav7">浮动盈亏率</div>
            <div class="nav nav8">通知</div>
          </div>
        </el-affix>

        <div class="list_box">
          <div class="list_empty" v-if="stockHoldEmpty">
            暂无符合操作个股，空仓中
          </div>

          <div
            class="item_box"
            v-for="(item, index) in computedStockHoldList"
            :key="index"
            @click="msgDetailsClick(item, 1)"
          >
            <div class="collect" @click.stop="collectClick(item, index)">
              <el-icon :size="20" :color="item.collected == 1 ? '#F1F90C' : ''"
                ><StarFilled
              /></el-icon>
              <span>收藏</span>
            </div>

            <div class="stock_box">
              <div class="name">{{ item.stockName }}</div>

              <div class="code">{{ item.stockCode }}</div>
            </div>

            <div class="time_box">{{ item.buyTime }}</div>

            <div class="price">
              {{ COMMON.formatToFixed(item.buyPrice) }}
            </div>

            <div class="zy">
              {{ COMMON.formatToFixed(item.stopProfitPrice) }}
            </div>

            <div class="zs">
              {{ COMMON.formatToFixed(item.stopLossPrice) }}
            </div>

            <div class="profit" :class="{ profit_lt: item.profitLoss < 0 }">
              {{ item.profitLoss >= 0 ? "+" : ""
              }}{{ COMMON.formatToFixed(item.profitLoss) }}%
            </div>

            <div class="inform_box" @click.stop="msgDetailsClick(item, 2)">
              <div class="content_box">
                <div class="content">{{ item.noticeList[0].content }}</div>

                <div class="btn">点击查看详情</div>
              </div>

              <div class="time">{{ item.noticeList[0].createTime }}</div>
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import { ElMessage } from "element-plus";

export default {
  props: {
    infoList: {},
    userInfo: {},
    pushStockList: {
      type: Array,
      default: () => [
        // { stockCode: 600231, price: 16.55 }
      ],
    },
    pushLatestList: {
      type: Object,
      default: () => {},
    },
  },
  data() {
    return {
      currentValue: 0,
      animationSpeed: 50, // 数值变化速度（毫秒）

      latestList: [], // 最新操作
      latestEmpty: false, // 最新操作 空 state
      openStatus: -1, // 股市开盘状态
      stockHoldList: [], // 当前持仓
      stockHoldEmpty: false, // 当前持仓 空 state
      pushedStockData: this.pushStockList,
      interval1: null,
    };
  },
  computed: {
    computedStockHoldList() {
      const rows = this.stockHoldList || [];
      return rows.map((item) => {
        const pushedItem = this.pushedStockData.find(
          (pushed) => pushed.stockCode === item.stockCode
        );
        const currentPrice = pushedItem?.price ?? item.currentPrice;
        const profitLoss =
          item.strategyStatus == 0
            ? ((currentPrice - item.buyPrice) / item.buyPrice) * 100 // 未卖出：用 现价计算
            : ((item.sellPrice - item.buyPrice) / item.buyPrice) * 100; // 已卖出：用 卖价计算
        return {
          ...item,
          currentPrice,
          profitLoss: profitLoss,
        };
      });
    },
  },
  created() {
    this.getLatestList(); // 获取 操作记录 list
    this.getStockHoldList(); // 获取 当前持仓 list
  },
  mounted() {
    // this.startCounter();

    this.getOpenStatus(); // 股市开盘状态
    this.interval1 = setInterval(() => {
      this.getOpenStatus();
    }, 5 * 60 * 1000);
  },
  beforeUnmount() {
    // this.stopCounter();
    clearInterval(this.interval1);
  },
  methods: {
    // 股市开盘状态
    getOpenStatus() {
      this.API.CLOUDGet("quant/api/ai-strategy/open-status", {}).then((res) => {
        // console.log(res);
        let datas = res.data?.data;
        // console.log(datas);

        // datas = 1;
        this.openStatus = datas;
      });
    },

    // 获取 最新操作 list
    getLatestList() {
      let data = {
        strategyId: this.infoList.id,
      };

      this.API.CLOUDGet("quant/api/ai-strategy/latest-operation", data).then(
        (res) => {
          // console.log(res);
          let datas = res.data?.data;
          // console.log(datas);

          if (datas) {
            this.latestList = datas;

            // this.latestList = [];

            this.latestEmpty = this.latestList.length > 0 ? false : true;
          }
        }
      );
    },

    // 获取 当前持仓 list
    getStockHoldList() {
      let data = {
        strategyId: this.infoList.id,
        userNo: this.userInfo.userNo,
      };

      this.API.CLOUDGet("quant/api/ai-strategy/current-hold", data).then(
        (res) => {
          // console.log(res);
          let datas = res.data?.data;
          // console.log(datas);

          if (datas) {
            this.stockHoldList = datas;

            // this.stockHoldList.length = 0;

            this.stockHoldEmpty = this.stockHoldList.length > 0 ? false : true;
          }
        }
      );
    },

    // 0 - 100 循环
    startCounter() {
      this.interval = setInterval(() => {
        this.currentValue++;
        if (this.currentValue > 100) {
          this.currentValue = 0;
        }
      }, this.animationSpeed);
    },
    stopCounter() {
      clearInterval(this.interval);
    },

    // 查看消息详情
    msgDetailsClick(item, type) {
      // console.log(item);

      let title = item.stockName;
      if (type == 2) {
        title = item.noticeList[0].title;
      }

      this.$emit("skipNotice", title);
    },

    // 收藏/取消收藏
    collectClick(item, index) {
      let action = item.collected == 0 ? "收藏" : "取消收藏";
      let url =
        item.collected == 0
          ? "quant/api/ai-strategy/collect/into"
          : "quant/api/ai-strategy/collect/cancel";

      let data = {
        userNo: this.userInfo.userNo,
        strategyId: this.infoList.id,
        stockId: item.id,
      };

      this.API.CLOUDPost1(url, data).then((res) => {
        // console.log(res);
        if (res.data.code == 200) {
          ElMessage.success(`${action}成功`);

          this.stockHoldList[index].collected = item.collected == 0 ? 1 : 0;
        } else {
          ElMessage.error(`${action}失败，请重试`);
        }
      });
    },
  },
  watch: {
    pushLatestList(newVal) {
      // console.log(newVal);

      let exists = this.latestList.some((item) => item.id === newVal.id);

      // 如果不存在，则添加到数组开头
      if (!exists) {
        this.latestList.unshift(newVal);

        this.latestEmpty = this.latestList.length > 0 ? false : true;
      }
    },
    pushStockList(newVal) {
      // console.log(newVal);
      this.pushedStockData = newVal;
    },
  },
};
</script>

<style lang="less" scoped>
.dqcz_wrap {
  padding: 36px 0;

  .sp_animation {
    width: 3px;
    background: #fff;
    vertical-align: middle;
    display: inline-block;

    &.sp_animation1 {
      margin-right: 6px;
      animation: telegraph-animation 1.5s infinite;
      animation-fill-mode: forwards;
    }

    &.sp_animation2 {
      margin-right: 6px;
      animation: telegraph-animation 1.5s infinite 0.2s;
      animation-fill-mode: forwards;
    }

    &.sp_animation3 {
      margin-right: 6px;
      animation: telegraph-animation 1.5s infinite 0.4s;
      animation-fill-mode: forwards;
    }

    &.sp_animation4 {
      margin-right: 6px;
      animation: telegraph-animation 1.5s infinite 0.6s;
      animation-fill-mode: forwards;
    }

    &.sp_animation5 {
      animation: telegraph-animation 1.5s infinite 0.8s;
      animation-fill-mode: forwards;
    }

    @keyframes telegraph-animation {
      0% {
        height: 12px;
      }

      50% {
        height: 0;
      }

      100% {
        height: 12px;
      }
    }
  }

  .title_box {
    font-size: 16px;
    font-weight: bold;
    display: flex;
    align-items: center;

    .text {
      margin-left: 30px;
      padding: 3px 10px;
      background: #28324b;
      display: flex;
      align-items: center;

      .txt1 {
        margin-right: 36px;
      }

      .counter_container {
        margin-left: 36px;

        .counter_value {
          span {
            display: inline-block;
            width: 32px;
            text-align: right;
          }
        }

        .open {
          font-weight: bold;
          font-size: 12px;
          position: relative;

          &::before {
            content: "";
            position: absolute;
            left: -12px;
            top: 50%;
            transform: translateY(-50%);
            width: 6px;
            height: 6px;
            border-radius: 50%;
            background-color: currentColor; /* 使用当前文字颜色 */
          }

          &.open1 {
            color: #f70d1a;
            animation: blink 1s linear infinite;

            @keyframes blink {
              0% {
                opacity: 1;
              }
              100% {
                opacity: 0;
              }
            }
          }
        }
      }
    }
  }

  .latest_box {
    .list_box {
      font-size: 14px;
      min-height: 20px;

      .list_empty {
        height: 48px;
        line-height: 48px;
        padding-top: 36px;
        text-align: center;

        .txt1 {
          font-weight: bold;
          margin-right: 18px;
        }
      }

      .item_box {
        margin-top: 36px;

        .stock_box {
          display: flex;

          .stock {
            width: 125px;
          }

          .time {
            margin-left: 24px;
          }

          .type {
            width: 100px;
            text-align: center;
            margin-left: 24px;
          }

          .price {
            width: 181px;
            margin-left: 24px;
          }

          .zyzs_box {
            margin-left: 24px;

            .zyzs {
              display: flex;

              div {
                margin-left: 24px;

                &:first-child {
                  margin-left: 0;
                }
              }
            }
          }
        }

        .inform_box {
          margin-top: 10px;
          font-weight: bold;
          display: flex;
          align-items: center;

          .time {
            font-weight: 400;
          }

          .content {
            margin-left: 4px;
            width: 500px;
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
          }

          .btn {
            cursor: pointer;
          }
        }
      }
    }
  }

  .stockHold_box {
    margin-top: 48px;
    border-top: 5px solid #28324b;
    padding-top: 24px;
    font-size: 14px;

    .list_container {
      margin-top: 20px;

      .list_nav {
        padding: 10px 14px;
        background: #1d2137;
        display: flex;
        justify-content: space-between;

        &.list_nav_length {
          // padding-right: 22px;
        }

        .nav {
          text-align: center;

          &.nav1 {
            min-width: 30px;
          }

          &.nav2 {
            min-width: 62px;
          }

          &.nav3 {
            min-width: 160px;
          }

          &.nav4 {
            min-width: 92px;
          }

          &.nav5 {
            min-width: 92px;
          }

          &.nav6 {
            min-width: 92px;
          }

          &.nav7 {
            min-width: 92px;
          }

          &.nav8 {
            width: 320px;
          }
        }
      }

      .list_box {
        margin-top: 24px;
        // height: 642px;
        // overflow: auto;

        .list_empty {
          padding-top: 120px;
          text-align: center;
          font-weight: bold;
        }

        .item_box {
          margin-top: 24px;
          padding: 4px 14px;
          text-align: center;
          display: flex;
          justify-content: space-between;
          align-items: center;

          &:first-child {
            margin-top: 0;
          }

          &:hover {
            background: #232e4a;
            cursor: pointer;
          }

          .collect {
            min-width: 30px;
            display: flex;
            flex-direction: column;
            align-items: center;
          }

          .stock_box {
            min-width: 62px;
            text-align: left;

            .code {
              margin-top: 4px;
            }
          }

          .time_box {
            min-width: 160px;
          }

          .price {
            min-width: 92px;
          }

          .zy {
            min-width: 92px;
          }

          .zs {
            min-width: 92px;
          }

          .profit {
            min-width: 92px;
            color: #ff0000;

            &.profit_lt {
              color: #26a374;
            }
          }

          .inform_box {
            width: 320px;

            .content_box {
              display: flex;
              font-weight: bold;

              .content {
                width: calc(100% - 92px);
                white-space: nowrap;
                overflow: hidden;
                text-overflow: ellipsis;
              }

              .btn {
                width: 92px;
              }
            }

            .time {
              text-align: left;
              margin-top: 4px;
              font-size: 12px;
            }
          }
        }

        &::-webkit-scrollbar {
          width: 8px; /* 滚动条宽度 */
        }

        /* 滚动条轨道 */
        &::-webkit-scrollbar-track {
          background: #050a1a; /* 轨道背景颜色 */
          border-radius: 5px; /* 轨道圆角 */
        }

        /* 滚动条滑块 */
        &::-webkit-scrollbar-thumb {
          background: #d8d8d8; /* 滑块颜色 */
          border-radius: 5px; /* 滑块圆角 */
        }

        /* 滚动条滑块悬停状态 */
        &::-webkit-scrollbar-thumb:hover {
          background: #d8d8d8; /* 滑块悬停颜色 */
        }

        /* 滚动条角落 */
        &::-webkit-scrollbar-corner {
          background: #fff; /* 角落背景颜色 */
        }
      }
    }
  }
}
</style>